module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/babel-runtime/core-js/object/define-property.js
// module id = ../../../node_modules/babel-runtime/core-js/object/define-property.js
// module chunks = 0